import { Component, OnInit, ViewEncapsulation, NgZone, OnDestroy } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import startersDetails from 'assets/json/starters.json'
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { environment } from 'environments/environment';
import { NFTService, NFTv2Service } from 'app/services/contract/contracts-services/nft.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { PlaydexService } from 'app/services/contract/contracts-services/playdex.service';
import { eContracts } from 'app/services/contract/contract.config';
import { first } from 'rxjs';
//import filters from '../../../../assets/json/filters.json'
//import {SimpleGlobal} from 'ngx-simple-global'


declare const analytics

interface MigrateResult {
  tokenId;
  genesArray;
  genes;
  deadline;
  v;
  r;
  s;
}

@Component({
  selector: 'app-kryptomons-old',
  templateUrl: './kryptomons.component.html',
  styleUrls: ['./kryptomons.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class KryptomonsComponentOLD implements OnInit, OnDestroy {

  //public filters
  // public account
  public kryptomonsV1: any = []
  public kryptomonsV2: any = []
  public kryptomonsV1Check: any = []
  public kryptomonsV2Check: any = []
  public parsedKryptomon: any = []
  public rankingArray = [{ name: "Elite", value: 3, exist: false }, { name: "Veteran", value: 2, exist: false }, { name: "Rookie", value: 1, exist: false }]
  public parsedSuccess
  public hatchingTime
  public parsingIndex
  public fetchKryptomon1
  public fetchKryptomon2
  public noKryptomons
  public isOnboarding
  public itHatchemall
  public rentedKryptomon: any = [];
  public timer
  public showVideoOverlay
  public timesUp
  public showStartersOverlay
  public canRedeemFree
  public apiResponseCheck
  public startertoHatch
  public evolutionTimes = [
    259200, //3 days
    2629743, //1 month
    63113852, //24 months
    94670778 //36 months
  ];
  text: any = {
    Year: '',
    Month: '',
    Weeks: "",
    Days: "",
    Hours: "",
    Minutes: "",
    Seconds: "",
    MilliSeconds: ""
  };

  divider = ':'

  public allPicked
  public startersDetails
  public startersLegend: any = ["fire", "water", "grass", "electro", "air", "ghost", "ground", "ice"]
  public starterPick: any = ['default', 'default', 'default']
  public pickedStarter: any = [{
    img: "./assets/img/Icon/Egg-random.png",
    description: "Choose the element you prefer for this Starter Slot."
  }, {
    img: "./assets/img/Icon/Egg-random.png",
    description: "Choose the element you prefer for this Starter Slot."
  }, {
    img: "./assets/img/Icon/Egg-random.png",
    description: "Choose the element you prefer for this Starter Slot."
  }]
  public isLoading
  public pickedStarterBack
  public starterKryptomons
  wallet: string;
  intervalUpdateKryptomon: NodeJS.Timeout;
  intervalHatchingStatus: NodeJS.Timeout;
  signInterval: NodeJS.Timeout;

  constructor(
    private deviceService: DeviceDetectorService,
    public zone: NgZone,
    public activeRoute: ActivatedRoute,
    public toastService: ToastService,
    public http: HttpClient,
    public router: Router,
    private userService: UserService,
    private web3Service: Web3Service,
    private nftService: NFTService,
    private nftv2Service: NFTv2Service,
    private contractsService: ContractsService,
    private playdexService: PlaydexService

  ) {
    //this.filters = filters;
    this.parsedSuccess = false;
    this.noKryptomons = false;
    this.showVideoOverlay = false;
    this.timesUp = false;
    this.showStartersOverlay = false;
    this.canRedeemFree = false;
    this.allPicked = false;
    this.isLoading = false;
    this.startersDetails = startersDetails;
    this.itHatchemall = false;
    this.startertoHatch = false;

    //forcebuild

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.localStorage.removeItem("somethingChanged")
      }
    });

    let timerCount = parseInt(this.getCookieValue("timer"));

    let nowTimestamp = Date.now();

    let timeElapsed = (nowTimestamp - timerCount) / 1000
    console.log(timeElapsed)

    if (timeElapsed < 180) {
      this.isOnboarding = true;
      this.timer = new Date();
      this.timer.setSeconds(this.timer.getSeconds() + (180 - timeElapsed));
      console.log(this.timer)
      console.log(Math.round(3 - timeElapsed / 60))

      this.intervalUpdateKryptomon = setInterval(() => {
        let nowTimestamp = Date.now();
        let timeElapsed = (nowTimestamp - timerCount) / 1000
        if (timeElapsed >= 180) {
          this.timesUp = true;
          clearInterval(this.intervalUpdateKryptomon)
          let c = 0;
          this.intervalHatchingStatus = setInterval(() => {
            this.refresHatchintStatus();
            c++;
            if (c == 10) {
              clearInterval(this.intervalHatchingStatus)
            }
          }, 1000)
        }
      }, 500)

    } else {
      this.timesUp = true;
    }
    this.wallet = this.userService._userInfoData.recordedWallet;
    //this.getKmonBalance();
    this.getHatchingTime();
    //this.setAllowance()
    this.checkStartersAmount();
    this.getKryptomons()
    this.checkPlaydex()
    //this.setAllowance();
    this.intervalUpdateKryptomon = setInterval(() => {
      this.getKryptomonsCheck();
      this.checkPlaydexChange()
      //this.checkStartersAmount();
    }, 60000);
    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe(async (item: any) => {
    //     this.account = item[0];
    //     if (this.account !== undefined && this.account !== "") {
    //       //this.getKmonBalance();
    //       this.getHatchingTime();
    //       //this.setAllowance()
    //       this.checkStartersAmount();
    //       this.getKryptomons()
    //       this.checkPlaydex()
    //       //this.setAllowance();
    //       setInterval(() => {
    //         this.getKryptomonsCheck();
    //         this.checkPlaydexChange()
    //         //this.checkStartersAmount();
    //       }, 60000)
    //       console.log(this.account)
    //     }
    //   });
    // } else {
    //   this.account = this.appComponent.accounts[0];
    //   //this.getKmonBalance();
    //   this.getHatchingTime();
    //   //this.setAllowance()
    //   this.getKryptomons()
    //   this.checkPlaydex()
    //   this.checkStartersAmount()
    //   setInterval(() => {
    //     this.getKryptomonsCheck();
    //     this.checkPlaydexChange()
    //   }, 60000)
    //   //this.setAllowance();

    //   console.log(this.account)
    // }
  }
  ngOnDestroy(): void {
    if (this.intervalUpdateKryptomon) {
      clearInterval(this.intervalUpdateKryptomon);
    };
    if (this.intervalHatchingStatus) {
      clearInterval(this.intervalHatchingStatus);
    };
    if (this.signInterval) {
      clearInterval(this.signInterval);
    };
  }

  openGame() {
    if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
      console.log(this.deviceService.getDeviceInfo())
      if (this.deviceService.getDeviceInfo().os == 'iOS') {
        window.open("https://testflight.apple.com/join/CkBY8AAq", '_blank').focus();
      } else {
        window.open("https://play.google.com/store/apps/details?id=com.KryptomonCompany.Kryptomon&pli=1", '_blank').focus();
      }
      this.isOnboarding = false
    } else {
      this.router.navigate(["/play"])
    }
  }

  async checkStartersAmount() {
    this.http.get(environment.apiBaseUrlV22 + "kryptomon-starters/wallet/" + this.wallet).subscribe((item: any) => {
      console.log(item)
      if (!item) {
        this.canRedeemFree = true;
      } else {
        if (item.starter_kryptomons_generated_count < 1) {
          this.canRedeemFree = true;
        } else {
          this.canRedeemFree = false;
        }
      }
    })
  }

  async getKryptomons() {
    this.kryptomonsV1 = [];
    this.kryptomonsV2 = [];
    console.log('getKryptomons');

    this.nftService.ownedKryptomons(this.wallet).subscribe(
      receipt => {
        console.log('ownedKryptomons', receipt);
        if (receipt.length > 0) {
          for (let i = 0; i < receipt.length; i += 1) {
            this.kryptomonsV1.push({ tokenId: receipt[i], isMigrating: false });
          }
          this.fetchKryptomon1 = true;
        } else {
          this.fetchKryptomon1 = false;
        }
      },
      err => console.log('ownedKryptomons', err)
    );

    this.nftv2Service.ownedKryptomons(this.wallet).subscribe(
      receipt => {
        console.log('ownedKryptomonsV2', receipt);
        if (receipt.length > 0) {
          for (let i = 0; i < receipt.length; i += 1) {
            this.kryptomonsV2.push({ tokenId: receipt[i], isMigrating: false });
          }
          this.parsingIndex = 0;
          this.noKryptomons = false;
          this.populatePage(this.parsingIndex, false)
        } else {
          this.fetchKryptomon2 = false;
          if (!this.fetchKryptomon2 && !this.fetchKryptomon1) {
            console.log('nokryptomon')
            this.parsingIndex = 0;
            this.populatePage(this.parsingIndex, false)
          } else if (!this.fetchKryptomon2 && this.fetchKryptomon1) {
            this.parsingIndex = 0;
            this.noKryptomons = false;
            this.populatePage(this.parsingIndex, false)
          }
        }
      },
      err => console.log('ownedKryptomonsV2', err)
    );

    // await this.appComponent.contractService.contractInstance.methods
    //   .ownedKryptomons()
    //   .call({
    //     from: this.wallet,
    //   })
    //   .then(async (receipt) => {
    //     console.log(receipt);
    //     if (receipt.length > 0) {
    //       for (let i = 0; i < receipt.length; i += 1) {
    //         //this.getKryptomonDetails(receipt[i]);
    //         this.kryptomonsV1.push({ tokenId: receipt[i], isMigrating: false });
    //       }
    //       this.fetchKryptomon1 = true;
    //     } else {
    //       this.fetchKryptomon1 = false;
    //     }
    //     await this.appComponent.contractService.contractInstanceV2.methods
    //       .ownedKryptomons()
    //       .call({
    //         from: this.account,
    //       })
    //       .then((receipt) => {
    //         console.log(receipt);
    //         if (receipt.length > 0) {
    //           for (let i = 0; i < receipt.length; i += 1) {
    //             //this.getKryptomonsDetails(receipt[i]);
    //             this.kryptomonsV2.push({ tokenId: receipt[i], isMigrating: false });
    //           }
    //           this.parsingIndex = 0;
    //           this.noKryptomons = false;
    //           this.populatePage(this.parsingIndex, false)
    //         } else {
    //           this.fetchKryptomon2 = false;
    //           if (!this.fetchKryptomon2 && !this.fetchKryptomon1) {
    //             console.log('nokryptomon')
    //             //this.noKryptomons = true;
    //             this.parsingIndex = 0;
    //             this.populatePage(this.parsingIndex, false)
    //           } else if (!this.fetchKryptomon2 && this.fetchKryptomon1) {
    //             this.parsingIndex = 0;
    //             this.noKryptomons = false;
    //             this.populatePage(this.parsingIndex, false)
    //           }
    //         }
    //         //this.fetchKryptomon = true;

    //       }).catch((err) => {
    //         console.log(err, 'err')
    //         //this.fetchKryptomon = true;
    //       });
    //   })
    //   .catch((err) => {
    //     console.log(err, 'err');
    //     //this.fetchKryptomon = true;
    //   });

  }

  refresHatchintStatus() {
    for (let i = 0; i < this.parsedKryptomon.length; i++) {
      if (!this.parsedKryptomon[i].data.isReadyToHatch && this.parsedKryptomon[i].data.status == 0) {
        this.parsedKryptomon[i].data.hatchingDate = this.getHatchingDate(this.parsedKryptomon[i].data.timeBorn, this.parsedKryptomon[i].data.isStarter);
        this.parsedKryptomon[i].data.isReadyToHatch = this.parsedKryptomon[i].data.hatchingDate * 1000 < Date.now() && this.parsedKryptomon[i].data.status == 0;
      }
    }
  }

  getKryptomonsCheck() {
    console.log('check kryptomons')
    this.kryptomonsV2Check = [];
    this.kryptomonsV1Check = [];
    this.nftService.ownedKryptomons(this.wallet).subscribe(
      receipt => {
        if (receipt.length > 0) {
          for (let i = 0; i < receipt.length; i += 1) {
            //this.getKryptomonDetails(receipt[i]);
            this.kryptomonsV1Check.push({ tokenId: receipt[i], isMigrating: false });

          }
          this.fetchKryptomon1 = true;
        } else {
          this.fetchKryptomon1 = false;
        }
      },
      err => console.log('ownedKryptomons', err)
    );

    this.nftv2Service.ownedKryptomons(this.wallet).pipe(first()).subscribe(
      receipt => {
        if (receipt.length > 0) {
          for (let i = 0; i < receipt.length; i += 1) {
            this.kryptomonsV2Check.push({ tokenId: receipt[i], isMigrating: false });
          }
          if (this.kryptomonsV2Check.length !== this.kryptomonsV2.length || this.kryptomonsV1Check.length !== this.kryptomonsV1.length) {
            console.log('here-fuck')
            this.parsingIndex = 0;
            this.populatePage(this.parsingIndex, true);
          }
        } else {
          this.fetchKryptomon2 = false;
          if (!this.fetchKryptomon2 && !this.fetchKryptomon1) {

            this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/kryptomons/detail?offset=0&limit=1000").pipe(first()).subscribe(async (response: any) => {
              console.log(response)
              if (response.length !== this.apiResponseCheck || response.length == 0) {
                console.log('nokryptomon')
                //this.noKryptomons = true;
                this.parsingIndex = 0;
                this.populatePage(this.parsingIndex, true)
              }
            })

          } else if (!this.fetchKryptomon2 && this.fetchKryptomon1) {
            if (this.kryptomonsV1Check.length !== this.kryptomonsV1.length) {
              this.parsingIndex = 0;
              this.noKryptomons = false;
              this.populatePage(this.parsingIndex, true)
            }
          }
        }
      },
      err => console.log('ownedKryptomonsV2', err)
    );












    // await this.appComponent.contractService.contractInstance.methods
    //   .ownedKryptomons()
    //   .call({
    //     from: this.account,
    //   })
    //   .then(async (receipt) => {
    //     if (receipt.length > 0) {
    //       for (let i = 0; i < receipt.length; i += 1) {
    //         //this.getKryptomonDetails(receipt[i]);
    //         this.kryptomonsV1Check.push({ tokenId: receipt[i], isMigrating: false });

    //       }
    //       this.fetchKryptomon1 = true;
    //     } else {
    //       this.fetchKryptomon1 = false;
    //     }
    //     await this.appComponent.contractService.contractInstanceV2.methods
    //       .ownedKryptomons()
    //       .call({
    //         from: this.account,
    //       })
    //       .then((receipt) => {
    //         if (receipt.length > 0) {
    //           for (let i = 0; i < receipt.length; i += 1) {
    //             this.kryptomonsV2Check.push({ tokenId: receipt[i], isMigrating: false });
    //           }
    //           if (this.kryptomonsV2Check.length !== this.kryptomonsV2.length || this.kryptomonsV1Check.length !== this.kryptomonsV1.length) {
    //             console.log('here-fuck')
    //             this.parsingIndex = 0;
    //             this.populatePage(this.parsingIndex, true);
    //           }
    //         } else {
    //           this.fetchKryptomon2 = false;
    //           if (!this.fetchKryptomon2 && !this.fetchKryptomon1) {

    //             this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/kryptomons/detail?offset=0&limit=1000").subscribe(async (response: any) => {
    //               console.log(response)
    //               if (response.length !== this.apiResponseCheck || response.length == 0) {
    //                 console.log('nokryptomon')
    //                 //this.noKryptomons = true;
    //                 this.parsingIndex = 0;
    //                 this.populatePage(this.parsingIndex, true)
    //               }
    //             })

    //           } else if (!this.fetchKryptomon2 && this.fetchKryptomon1) {
    //             if (this.kryptomonsV1Check.length !== this.kryptomonsV1.length) {
    //               this.parsingIndex = 0;
    //               this.noKryptomons = false;
    //               this.populatePage(this.parsingIndex, true)
    //             }
    //           }
    //         }
    //         //this.fetchKryptomon = true;

    //       }).catch((err) => {
    //         console.log(err, 'err')
    //         //this.fetchKryptomon = true;
    //       });
    //   })
    //   .catch((err) => {
    //     console.log(err, 'err');
    //     //this.fetchKryptomon = true;
    //   });
  }
  //https://api-v22.kryptomon.co/
  //https://api-staging-n7ni4.ondigitalocean.app
  async populatePage(index, refresh) {
    this.parsedSuccess = false;
    this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/kryptomons/detail?offset=0&limit=1000").subscribe(async (response: any) => {
      console.log(response)
      this.apiResponseCheck = response.length
      if (response.length > 0) {
        if (refresh) {
          this.parsedKryptomon = []
        }
        //
        this.rankingArray = [{ name: "Elite", value: 3, exist: false }, { name: "Veteran", value: 2, exist: false }, { name: "Rookie", value: 1, exist: false }]
        var rentedKryptomons = 0;
        for (let i = 0; i < response.length; i++) {
          let id = response[i].tokenId
          const checkTokenId = obj => obj.tokenId === id;
          if (!this.kryptomonsV2.some(checkTokenId)) {
            if (!response[i].rental && !response[i].isStarter) {
              response.splice(i, 1);
            } else {
              rentedKryptomons++
            }
          }
        }
        this.parseKryptomon(index, response)
        /*if(rentedKryptomons>0){
          analytics.track("has_borrowed_kryptomons",{amount:rentedKryptomons})
        }*/
      } else {
        console.log(this.rentedKryptomon.length)
        if (this.rentedKryptomon.length == 0 && !this.fetchKryptomon1) {
          this.noKryptomons = true;
        } else if (this.fetchKryptomon1) {
          this.rankingArray = this.rankingArray.filter(item => item.exist);
          this.parsedSuccess = true;
        }
      }
    })

  }

  parseKryptomon(index, response) {
    console.log('parsing')
    console.log(index)
    console.log(response.length)
    if (index < response.length) {
      let i = index;
      console.log(i)
      let item = response[i]
      let id = item.tokenId;
      //https://nft-server-h9u8n.ondigitalocean.app
      //https://nft-server-testnet-zi5m9.ondigitalocean.app/
      this.http.get("https://nft-server-h9u8n.ondigitalocean.app/v1/nfts?contractAddress=0x04b0f7d5cb2ce4688497f2525748fb7a9affa394&tokenId=" + id).subscribe((extraMarketData: any) => {
        console.log(extraMarketData)
        if (!item.isStarter) {
          item.order = extraMarketData.data[0].order;
        }
        if (item.ranking < 650) {
          item.tierName = "Rookie"
          item.tierNumber = 1
          this.rankingArray[2].exist = true;
        } else if (item.ranking >= 650 && item.ranking < 700) {
          item.tierName = "Veteran"
          item.tierNumber = 2
          this.rankingArray[1].exist = true;
        } else {
          item.tierName = "Elite"
          item.tierNumber = 3
          this.rankingArray[0].exist = true;
        }

        if (item.status > 1 && !item.isStarter) {
          if (!extraMarketData.data[0].nft.data.kryptomon.breedingCount) {
            item.breedingDone = 0;
          } else {
            item.breedingDone = extraMarketData.data[0].nft.data.kryptomon.breedingCount;
          }

          if (!extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) {
            extraMarketData.data[0].nft.data.kryptomon.breedingsLeft = 0;
          }

          item.breedingTotal = parseInt(extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) + parseInt(item.breedingDone)
        }
        if (item.status == 0) {

          var imageSelected

          if (item.genes.xFactor == 1) {
            imageSelected = "super"
          } else {
            imageSelected = item.speciality.toLowerCase()
          }

          if (item.extraData.unfreezable == 1) {
            item.image = "./assets/img/top_special/" + item.elementType + "/" + imageSelected + ".png";
          } else {
            if (item.tokenId == 6188) {
              item.image = "./assets/img/top_special/custom/6188.png";
            } else {
              item.image = "./assets/img/" + item.elementType + "/" + imageSelected + ".png";
            }

          }
        } else if (item.status == 1) {
          item.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_" + item.tokenId + "_png.png"
        } else if (item.status == 2) {
          item.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons-junior/png/kmon_" + item.tokenId + "_png.png"
        }

        if (item.timeHatched !== null) {
          const date = new Date(item.timeHatched * 1000);
          const yyyy = date.getFullYear();
          let mm: any = date.getMonth() + 1; // Months start at 0!
          let dd: any = date.getDate();

          if (dd < 10) dd = '0' + dd;
          if (mm < 10) mm = '0' + mm;

          const timeHatchedFormatted = dd + '/' + mm + '/' + yyyy;

          item.timeHatchedFormatted = timeHatchedFormatted;
        }

        const evolutionTime = this.evolutionTimes[item.status];
        if (item.isStarter) {
          var nextEvolution = (parseInt(item.timeHatched) + (evolutionTime * 1000));
        } else {
          var nextEvolution = (parseInt(item.timeHatched) + evolutionTime) * 1000;
        }

        if (item.isStarter && item.status == 0) {
          this.startertoHatch = true;
        }

        item.hatchingDate = this.getHatchingDate(item.timeBorn, item.isStarter);
        item.hatchingDateFormatted = new Date(item.hatchingDate * 1000)
        item.isReadyToHatch = item.hatchingDate * 1000 < Date.now() && item.status == 0;
        item.isReadyToEvolve = nextEvolution < Date.now() && item.status > 0;

        if (!item.name) {
          if (item.isStarter) {
            item.name = "S-" + (item.tokenId - 1000000000)
          } else {
            item.name = "#" + item.tokenId
          }

        }
        if (item.genes.sex <= 5) {
          item.genderIcon = "./assets/img/Icon/female-icon.svg"
        } else {
          item.genderIcon = "./assets/img/Icon/male-icon.svg"
        }

        item.mainFamilyImage = "./assets/img/icons/" + item.elementType.toLowerCase() + ".svg";
        item.secondaryFamilyImage = "./assets/img/icons/" + item.elementTypeSecond.toLowerCase() + ".svg";

        if (!item.babyRenderedStatus && !item.juniorRenderedStatus && !item.isStarter) {
          console.log(item.id)
          console.log('meta not stored')
          let metaObject: any = {}
          metaObject.typeFormatted = item.elementType;
          metaObject.super = item.genes.xFactor;
          metaObject.id = item.tokenId;
          metaObject.generation = item.genes.generation;
          metaObject.speciality = item.speciality;
          metaObject.talent = item.elementTalent;
          metaObject.unfreezable = item.extraData.unfreezable;
          metaObject.timeBornUnix = item.timeBorn;
          metaObject.image = item.image;

          let personalityObject: any = {}
          personalityObject.Affection = item.genes.affections
          personalityObject.Braveness = item.genes.brave
          personalityObject.Constitution = item.genes.constitution
          personalityObject.Crazyness = item.genes.crazyness
          personalityObject.Ego = item.genes.ego
          personalityObject.Hunger = item.genes.hunger
          personalityObject.Instinct = item.genes.instinct
          personalityObject.Laziness = item.genes.laziness
          personalityObject.Smart = item.genes.smart

          metaObject.personality = personalityObject;
          let post = {
            meta: metaObject,
            dna: Object.values(item.genes),
            network: this.web3Service.getNetworkName()
          }

          console.log(post)

          this.http.post(environment.apiBaseUrl + "json/kryptomon/save_meta.php", post).subscribe((item) => {
            console.log(item)
          }, (error) => {
            //console.log(error)
          })
        }

        this.parsedKryptomon.push({ data: item });

        this.parsingIndex++
        this.parseKryptomon(this.parsingIndex, response)
        this.parsingIndex++
        this.parseKryptomon(this.parsingIndex, response)
        this.parsingIndex++
        this.parseKryptomon(this.parsingIndex, response)

      })
    } else if (index / 3 == response.length) {
      this.parsedSuccess = true;
      this.rankingArray = this.rankingArray.filter(item => item.exist);
      console.log(this.parsedKryptomon)
    }
  }


  getHatchingDate(timeBorn, isFreeToPlay) {
    if (isFreeToPlay) {
      var hatchingDateInUnix: any = (parseInt(timeBorn) / 1000) + 180
    } else {
      var hatchingDateInUnix: any = parseInt(timeBorn) + this.hatchingTime;
    }
    return (hatchingDateInUnix + 20);
  }

  /* async */ getHatchingTime() {
    // this.hatchingTime = parseInt(await this.appComponent.contractService.contractInstance.methods.timeToHatch().call());
    this.nftService.timeToHatch().subscribe(htime => this.hatchingTime = parseInt(htime));
  }

  migrateKryptomon(kryptomon, index) {
    console.log(kryptomon)
    this.kryptomonsV1[index].isMigrating = true;
    //this.isLoading = true;

    // const isApproved = await this.appComponent.contractService.contractInstance.methods.isApprovedForAll(this.account, this.appComponent.contractService.contractInstanceV2._address).call();
    this.nftService.isApprovalForAll(this.wallet, this.contractsService.getContractAddress(eContracts.KMONFTV2)).subscribe(
      isApproved => {
        if (!isApproved) {
          this.nftService.setApprovalForAll(this.wallet, this.contractsService.getContractAddress(eContracts.KMONFTV2), true).subscribe(
            isApprovedForAll => {
              if (isApprovedForAll) this._migrateKryptomon(kryptomon, index);
            }
          )
        } else {
          this._migrateKryptomon(kryptomon, index);
        }
      }
    );

    // if (!isApproved) {
    //   await this.appComponent.contractService.contractInstance.methods.setApprovalForAll(this.appComponent.contractService.contractInstanceV2._address, true).send({ from: this.account });
    // }

    // const migrationData: MigrateResult = await this.http.get(this.appComponent.contractService.apiEndPoint + "/kryptomon/migrate/" + kryptomon.tokenId).toPromise() as MigrateResult;

    // ids.push(kryptomon.tokenId);
    // genes.push(migrationData.genesArray);
    // deadlines.push(migrationData.deadline);
    // vs.push(migrationData.v);
    // rs.push(migrationData.r);
    // ss.push(migrationData.s);

    // this.appComponent.contractService.contractInstanceV2.methods
    //   .migrateBatch(
    //     ids,
    //     genes,
    //     deadlines,
    //     vs,
    //     rs,
    //     ss
    //   )
    //   .send({ from: this.account })
    //   .then(() => {
    //     this.getKryptomons();
    //     analytics.track("upgraded kryptomon", { type: "migrate" })
    //   }).catch((err) => {
    //     this.kryptomonsV1[index].isMigrating = false;
    //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 });
    //   })
  }

  async _migrateKryptomon(kryptomon, index) {

    const ids: any[] = [];
    const genes: any[] = [];
    const deadlines: any[] = [];
    const vs: any[] = [];
    const rs: any[] = [];
    const ss: any[] = [];
    const migrationData: MigrateResult = await this.http.get(environment.apiBaseUrlV22 + "/kryptomon/migrate/" + kryptomon.tokenId).toPromise() as MigrateResult;

    ids.push(kryptomon.tokenId);
    genes.push(migrationData.genesArray);
    deadlines.push(migrationData.deadline);
    vs.push(migrationData.v);
    rs.push(migrationData.r);
    ss.push(migrationData.s);
    this.nftv2Service.migrateBatch(this.wallet, ids, genes, deadlines, vs, rs, ss).subscribe(
      () => {
        this.getKryptomons();
        // analytics.track("upgraded kryptomon", { type: "migrate" })
      }, err => {
        this.kryptomonsV1[index].isMigrating = false;
        this.toastService.genericError();
      }
    );
    // this.appComponent.contractService.contractInstanceV2.methods
    //   .migrateBatch(
    //     ids,
    //     genes,
    //     deadlines,
    //     vs,
    //     rs,
    //     ss
    //   )
    //   .send({ from: this.account })
    //   .then(() => {
    //     this.getKryptomons();
    //     analytics.track("upgraded kryptomon", { type: "migrate" })
    //   }).catch((err) => {
    //     this.kryptomonsV1[index].isMigrating = false;
    //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 });
    //   })
  }

  async checkPlaydexChange() {
    console.log('check playdex')

    this.playdexService.getLenderOffersNumber("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.wallet).subscribe(listedBalance => {
      console.log(listedBalance);

      const listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
        return this.playdexService.contract.methods.getTokenOfLenderByIndex("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.wallet, i).call();
      });
      const listedTokenIds = Promise.all(listedPromises)
      listedTokenIds.then((item) => {
        if (this.rentedKryptomon.length !== item.length) {
          this.checkPlaydex();
        }


      })

      // const listedBalance = await this.appComponent.contractService.playdexContract.methods.getLenderOffersNumber("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.account).call();


      // console.log(listedBalance)
      // const listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
      //   return this.appComponent.contractService.playdexContract.methods.getTokenOfLenderByIndex("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.account, i).call();
      // });
      // const listedTokenIds = Promise.all(listedPromises)
      // listedTokenIds.then((item) => {
      //   if (this.rentedKryptomon.length !== item.length) {
      //     this.checkPlaydex();
      //   }
    })
  }

  async checkPlaydex() {
    this.playdexService.getLenderOffersNumber("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.wallet).subscribe(
      listedBalance => {
        console.log(listedBalance)
        const listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
          return this.playdexService.contract.methods.getTokenOfLenderByIndex("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.wallet, i).call();
        });
        const listedTokenIds = Promise.all(listedPromises)
        listedTokenIds.then((item) => {
          this.rentedKryptomon = item;
          console.log(item)
          if (this.rentedKryptomon.length > 0) {
            for (let i = 0; i < this.rentedKryptomon.length; i++) {
              this.parseRentedKryptomon(this.rentedKryptomon[i])
            }
          }
        })
      }
    )
    // const listedBalance = await this.appComponent.contractService.playdexContract.methods.getLenderOffersNumber("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.account).call();
    // console.log(listedBalance)
    // const listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
    //   return this.appComponent.contractService.playdexContract.methods.getTokenOfLenderByIndex("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.account, i).call();
    // });
    // const listedTokenIds = Promise.all(listedPromises)
    // listedTokenIds.then((item) => {
    //   this.rentedKryptomon = item;
    //   console.log(item)
    //   if (this.rentedKryptomon.length > 0) {
    //     for (let i = 0; i < this.rentedKryptomon.length; i++) {
    //       this.parseRentedKryptomon(this.rentedKryptomon[i])
    //     }
    //   }
    // })
  }

  parseRentedKryptomon(id) {
    this.http.get("https://nft-server-h9u8n.ondigitalocean.app/v1/nfts?contractAddress=0x04b0f7d5cb2ce4688497f2525748fb7a9affa394&tokenId=" + id).subscribe(async (extraMarketData: any) => {
      console.log(extraMarketData)
      await this.http.get(environment.apiBaseUrlV22 + "kryptomon/" + id).subscribe(async (item: any) => {

        item.isRentedOut = true;
        item.order = extraMarketData.data[0].order;
        if (item.ranking < 650) {
          item.tierName = "Rookie"
          item.tierNumber = 1
          this.rankingArray[2].exist = true;
        } else if (item.ranking >= 650 && item.ranking < 700) {
          item.tierName = "Veteran"
          item.tierNumber = 2
          this.rankingArray[1].exist = true;
        } else {
          item.tierName = "Elite"
          item.tierNumber = 3
          this.rankingArray[0].exist = true;
        }

        if (item.status > 1) {
          if (!extraMarketData.data[0].nft.data.kryptomon.breedingCount) {
            item.breedingDone = 0;
          } else {
            item.breedingDone = extraMarketData.data[0].nft.data.kryptomon.breedingCount;
          }

          if (!extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) {
            extraMarketData.data[0].nft.data.kryptomon.breedingsLeft = 0;
          }

          item.breedingTotal = parseInt(extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) + parseInt(item.breedingDone)
        }
        if (item.status == 0) {

          var imageSelected

          if (item.genes.xFactor == 1) {
            imageSelected = "super"
          } else {
            imageSelected = item.speciality.toLowerCase()
          }

          if (item.extraData.unfreezable == 1) {
            item.image = "./assets/img/top_special/" + item.elementType + "/" + imageSelected + ".png";
          } else {
            item.image = "./assets/img/" + item.elementType + "/" + imageSelected + ".png";
          }
        } else if (item.status == 1) {
          item.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_" + item.tokenId + "_png.png"
        } else if (item.status == 2) {
          item.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons-junior/png/kmon_" + item.tokenId + "_png.png"
        }

        if (item.timeHatched !== null) {
          const date = new Date(item.timeHatched * 1000);
          const yyyy = date.getFullYear();
          let mm: any = date.getMonth() + 1; // Months start at 0!
          let dd: any = date.getDate();

          if (dd < 10) dd = '0' + dd;
          if (mm < 10) mm = '0' + mm;

          const timeHatchedFormatted = dd + '/' + mm + '/' + yyyy;

          item.timeHatchedFormatted = timeHatchedFormatted;
        }

        const evolutionTime = this.evolutionTimes[item.status];
        if (item.isStarter) {
          var nextEvolution = (parseInt(item.timeHatched) + (evolutionTime) * 1000);
        } else {
          var nextEvolution = (parseInt(item.timeHatched) + evolutionTime) * 1000;
        }


        item.hatchingDate = this.getHatchingDate(item.timeBorn, item.isStarter);
        item.hatchingDateFormatted = new Date(item.hatchingDate * 1000)
        item.isReadyToHatch = item.hatchingDate * 1000 < Date.now() && item.status == 0;
        item.isReadyToEvolve = nextEvolution < Date.now() && item.status > 0;

        if (!item.name) {
          item.name = "#" + item.tokenId
        }
        if (item.genes.sex <= 5) {
          item.genderIcon = "./assets/img/Icon/female-icon.svg"
        } else {
          item.genderIcon = "./assets/img/Icon/male-icon.svg"
        }

        item.mainFamilyImage = "./assets/img/icons/" + item.elementType.toLowerCase() + ".svg";
        item.secondaryFamilyImage = "./assets/img/icons/" + item.elementTypeSecond.toLowerCase() + ".svg";

        if (!item.babyRenderedStatus && !item.juniorRenderedStatus) {
          console.log(item.id)
          console.log('meta not stored')
          let metaObject: any = {}
          metaObject.typeFormatted = item.elementType;
          metaObject.super = item.genes.xFactor;
          metaObject.id = item.tokenId;
          metaObject.generation = item.genes.generation;
          metaObject.speciality = item.speciality;
          metaObject.talent = item.elementTalent;
          metaObject.unfreezable = item.extraData.unfreezable;
          metaObject.timeBornUnix = item.timeBorn;
          metaObject.image = item.image;

          let personalityObject: any = {}
          personalityObject.Affection = item.genes.affections
          personalityObject.Braveness = item.genes.brave
          personalityObject.Constitution = item.genes.constitution
          personalityObject.Crazyness = item.genes.crazyness
          personalityObject.Ego = item.genes.ego
          personalityObject.Hunger = item.genes.hunger
          personalityObject.Instinct = item.genes.instinct
          personalityObject.Laziness = item.genes.laziness
          personalityObject.Smart = item.genes.smart

          metaObject.personality = personalityObject;
          let post = {
            meta: metaObject,
            dna: Object.values(item.genes),
            network: this.web3Service.getNetworkName()
          }

          console.log(post)

          this.http.post("https://api.kryptomon.co/json/kryptomon/save_meta.php", post).subscribe((item) => {
            console.log(item)
          }, (error) => {
            //console.log(error)
          })
        }
        //this.noKryptomons = false            
        this.parsedKryptomon.push({ data: item });
        console.log(this.parsedKryptomon)
        console.log(this.kryptomonsV2.length)
        if (this.kryptomonsV2.length == 0) {
          this.rankingArray = this.rankingArray.filter(item => item.exist);
          this.parsedSuccess = true;
        }
      })
    })
  }

  selectElementStarter(index) {
    this.pickedStarter[index] = this.startersDetails.find((item) => {
      return item.element == this.starterPick[index]
    })
    if (this.pickedStarter[0].element !== undefined && this.pickedStarter[1].element !== undefined && this.pickedStarter[2].element !== undefined) {
      this.allPicked = true;
      this.pickedStarterBack = JSON.parse(JSON.stringify(this.pickedStarter))
    } else {
      this.allPicked = false;
    }
  }

  generateStarters(secret, timestamp, intervalOne) {

    analytics.track('clicked button', {
      section: 'premium f2p',
      value: 'confirm selection',
      step: 'step 2',
      elements: [this.pickedStarter[0].element, this.pickedStarter[1].element, this.pickedStarter[2].element]
    });

    let post = {
      kryptomons: [this.pickedStarter[0].element, this.pickedStarter[1].element, this.pickedStarter[2].element],
      walletId: this.wallet,
      signatureHash: secret,
      timestamp: timestamp,
    }

    console.log(post)

    this.http.post("https://api.kryptomon.co/f2p/generateKryptomons.php", post).subscribe((item: any) => {
      console.log(item)
      this.isLoading = false;
      clearInterval(intervalOne)
      if (item.response == "done") {
        analytics.track('created synthetic', {
          user: 'f2p', // or ‘premium’
          elements: [this.pickedStarter[0].element, this.pickedStarter[1].element, this.pickedStarter[2].element] //array of the 3 elements
        })
        //this.starterKryptomons = item.kryptomons
        this.canRedeemFree = false;
        for (let i = 0; i < item.kryptomons.length; i++) {
          var imageSelected

          if (item.kryptomons[i].xFactor == 1) {
            imageSelected = "super"
          } else {
            imageSelected = item.kryptomons[i].speciality.toLowerCase()
          }

          item.kryptomons[i].image = "./assets/img/" + item.kryptomons[i].elementType + "/" + imageSelected + ".png";

          if (!item.kryptomons[i].name) {
            item.kryptomons[i].name = "S-" + (parseInt(item.kryptomons[i].id) - 1000000000)
          }
          if (item.kryptomons[i].sex < 5) {
            item.kryptomons[i].genderIcon = "./assets/img/Icon/female-icon.svg"
          } else {
            item.kryptomons[i].genderIcon = "./assets/img/Icon/male-icon.svg"
          }
          item.kryptomons[i].mainFamilyImage = "./assets/img/icons/" + item.kryptomons[i].elementType.toLowerCase() + ".svg";
          item.kryptomons[i].secondaryFamilyImage = "./assets/img/icons/" + item.kryptomons[i].elementTypeSecond.toLowerCase() + ".svg";
          if (item.tiers[i] == "Tier3") {
            item.kryptomons[i].tierName = "Rookie"
            item.kryptomons[i].tierNumber = 1
          } else if (item.tiers[i] == "Tier2") {
            item.kryptomons[i].tierName = "Veteran"
            item.kryptomons[i].tierNumber = 2
          } else {
            item.kryptomons[i].tierName = "Elite"
            item.kryptomons[i].tierNumber = 3
          }
        }
        this.starterKryptomons = item.kryptomons
      } else {
        console.log('err')
        this.pickedStarter = this.pickedStarterBack;
      }
      console.log(this.isLoading)
      //this.ref.detectChanges();
    }, (err) => {
      console.log(err)
      clearInterval(intervalOne)
      this.pickedStarter = this.pickedStarterBack;
      this.isLoading = false;
      //this.ref.detectChanges();
    })

  }

  signMessage() {
    this.signInterval = setInterval(() => {
      this.changeImage(0)
      this.changeImage(1)
      this.changeImage(2)
    }, 100)
    this.isLoading = true;
    let timestamp = Date.now();
    var text = "Generate my starter Kryptomons: " + timestamp;
    var msg = this.web3Service.utf8ToHex(text);
    var from = this.wallet;
    var params = [msg, from]
    var method = 'personal_sign'
    console.log(from);

    this.web3Service.getWeb3()/* this.appComponent.contractService.web3 */.currentProvider.sendAsync({
      method,
      params,
      from,
    }, (err: any, result: any) => {
      console.log('fired')
      this.zone.run(() => {
        if (err || result.error) {
          console.log(err);
          console.log(result)
          this.isLoading = false;
          clearInterval(this.signInterval)
          this.pickedStarter = this.pickedStarterBack
        } else {
          this.generateStarters(result.result, timestamp, this.signInterval)
        }
      })
    })
  }

  changeImage(index) {
    //console.log(index)
    let spec = ["attack", "balance", "defense", "super"]
    let rand = Math.floor(Math.random() * (3 - 0 + 1) + 0)
    this.pickedStarter[index].img = "./assets/img/" + this.pickedStarter[index].element.charAt(0).toUpperCase() + this.pickedStarter[index].element.slice(1) + "/" + spec[rand] + ".png"
  }

  openDetails(id) {
    this.router.navigate(['/kryptomons/details', id])
  }
  goToOnboarding() {
    //this.eraseCookie('skip-onboarding')
    this.router.navigate(['/onboarding/start'])
  }

  refreshPageAfterStarter() {

    this.parsingIndex = 0;
    this.populatePage(this.parsingIndex, true);
    this.closeStarterOverlay()
  }

  closeStarterOverlay() {
    analytics.track('clicked button', {
      section: 'premium f2p',
      value: 'close', // button or X symbol
      step: 'step 2'
    });
    this.showStartersOverlay = false;
  }

  async hatchEmAll() {
    this.isLoading = true;
    let timestamp = Date.now();
    var text = "Evolve my wallet " + this.wallet + " kryptomon to 1";
    var msg = await this.web3Service.utf8ToHex(text)
    var from = this.wallet;
    var params = [msg, from]
    var method = 'personal_sign'
    console.log(from)
    this.web3Service.getWeb3()/* this.appComponent.contractService.web3 */.currentProvider.sendAsync({
      method,
      params,
      from,
    }, (err: any, result: any) => {
      console.log('fired')
      this.zone.run(() => {
        if (err || result.error) {
          console.log(err);
          console.log(result)
          this.isLoading = true;
          this.toastService.genericError();
        } else {
          let post = {
            walletId: this.wallet,
            signatureHash: result.result,
            timestamp: timestamp
          }
          console.log(post)
          this.http.post("https://api.kryptomon.co/f2p/hatchWalletF2P.php", post).subscribe((item: any) => {
            console.log(item)
            if (item.response == 'done') {
              //window.localStorage.setItem('somethingChanged', 'true')
              setTimeout(() => {
                analytics.track("upgraded f2p kryptomon-all", { type: "hatch" })
                this.parsingIndex = 0;
                this.startertoHatch = false;
                this.populatePage(this.parsingIndex, true);
                this.isLoading = false;
                //this.isOnboarding = false;
                this.itHatchemall = true;
              }, 3000);
            } else {
              this.isLoading = false;
              this.toastService.genericError();
            }
          }, (err) => {
            this.isLoading = false;
            console.log(err)
            this.toastService.genericError();
          })
        }
      })
    })
  }

  ngOnInit() {

  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 60 * 1000 * 60 * 24));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    console.log('cookie-set')

  }

  getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  }
}